import { useState, useEffect } from 'react';

const useClipboard = (text, options) => {
  const [isCopied, setIsCopied] = useState(false);
  const duration = options && options.duration;

  useEffect(() => {
    let id;

    if (isCopied && duration) {
      id = setTimeout(() => {
        setIsCopied(false);
      }, duration);
    }

    return () => {
      if (id) {
        clearTimeout(id);
      }
    };
  }, [isCopied, duration]);

  const doCopy = async () => {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
        setIsCopied(true);
      } catch (e) {
        // Unsupported browser
      }
    }
  };

  return [isCopied, doCopy];
};

export default useClipboard;
